import gql from "graphql-tag";

export const removeFilterMutation = gql`
  mutation removeFilter($id: Number!) {
    removeFilter(id: $id) @client
  }
`;

const dirtyStateQuery = gql`
  query {
    dirtyState @client {
      filters {
        id
        type
        value
      }
    }
  }
`;

export const removeFilter = (_, { id }, { cache }) => {
  const { dirtyState } = cache.readQuery({ query: dirtyStateQuery });

  const data = {
    dirtyState: {
      __typename: "DirtyState",
      filters: dirtyState.filters.filter(filter => filter.id !== id),
    },
    articleMatchesPage: 1,
  };

  cache.writeData({ data });
  return null;
};



// WEBPACK FOOTER //
// ./src/mutations/removeFilterMutation.js